import type { RouteLocationRaw } from 'vue-router'
import type { NavigateToOptions } from '#app/composables/router'

export const getLinkType = (linkType: string) => {
  // 'section' a libovolný 'product-list-<value>' (dle kategorií gridu) se serializují jako 'tag'
  if (linkType === 'section' || /^product-list-.+/.test(linkType)) {
    return 'tag'
  }
  return linkType
}

export const appNavigateTo = async (to?: RouteLocationRaw | null, options?: NavigateToOptions) => {
  const { locale, dataLang } = useLocale()
  const requstURL = useRequestURL()
  const parsedOptions = JSON.parse(JSON.stringify(options ?? {}))
  const { public: config } = useRuntimeConfig()
  const nuxtApp = useNuxtApp()
  const localePath = useLocalePath()

  if (typeof to === 'string') {
    const toWithLocale = getURLFromHref(to)
    try {
      if (toWithLocale.host === requstURL.host) {
        return navigateTo(
          `${toWithLocale.pathname}${toWithLocale.search}${toWithLocale.hash}`,
          parsedOptions
        )
      } else {
        return navigateTo(toWithLocale.href, parsedOptions)
      }
    } catch (e) {
      console.log(e)
    }
  } else {
    const toWithLocale = JSON.parse(JSON.stringify(to))
    if (!options?.external) {
      if (!toWithLocale.query) {
        toWithLocale.query = {}
      }
      if (
        config.localesInQuery ||
        (nuxtApp.$sharedComponentsOptions &&
          'options' in nuxtApp.$sharedComponentsOptions &&
          nuxtApp.$sharedComponentsOptions?.options &&
          'i18n' in nuxtApp.$sharedComponentsOptions?.options &&
          typeof nuxtApp.$sharedComponentsOptions?.options?.i18n === 'object' &&
          'localesInQuery' in nuxtApp.$sharedComponentsOptions?.options?.i18n &&
          nuxtApp.$sharedComponentsOptions?.options?.i18n?.localesInQuery)
      ) {
        toWithLocale.query.lang = locale.value
        toWithLocale.query.dataLang = dataLang.value
      }
    }
    try {
      // Cíl zadaný jménem routy prožene localePath: při strategy 'prefix'
      // (@nuxtjs/i18n s vyplněnými locales) se routy jmenují
      // `<name>___<locale>` a holé jméno vue-router nenajde („No match for
      // {name: …}"). Projekty, kde se routy nelokalizují, tím nejsou dotčené —
      // localePath přejmenuje jen když lokalizovaná routa existuje
      // (routing.js: `if (router.hasRoute(localizedName))`), jinak vrátí
      // fullPath původního cíle.
      //
      // Fallback na původní objekt je schválně: localePath vrací '' když se
      // routa nenajde vůbec, a navigateTo('') by místo srozumitelné chyby
      // provedlo nesmyslnou navigaci.
      const localized =
        toWithLocale && typeof toWithLocale === 'object' && 'name' in toWithLocale
          ? localePath(toWithLocale)
          : null
      return navigateTo(localized || toWithLocale, options)
    } catch (e) {
      console.log(e)
    }
  }
}
export const getURLFromHref = (href: string | Ref<string>) => {
  const { locale, dataLang } = useLocale()
  const { public: config } = useRuntimeConfig()

  let hrefWithLang: URL
  const requstURL = useRequestURL()
  try {
    hrefWithLang = new URL(unref(href)) // zkusí absolutní
  } catch (err) {
    // když selže, je to relativní => přidej base
    hrefWithLang = new URL(unref(href), requstURL.origin)
  }
  if (requstURL.origin === hrefWithLang.origin && config.localesInQuery) {
    hrefWithLang.searchParams.set('lang', locale.value)
    hrefWithLang.searchParams.set('dataLang', dataLang.value)
  }
  return hrefWithLang
}
